const ENCRYPTION_KEY = 'tennis_partner_id_key_2024';

export function encryptPartnerId(partnerId: string): string {
  if (!partnerId) {
    return '';
  }

  try {
    let encrypted = '';
    const key = ENCRYPTION_KEY;
    
    for (let i = 0; i < partnerId.length; i++) {
      const charCode = partnerId.charCodeAt(i) ^ key.charCodeAt(i % key.length);
      encrypted += String.fromCharCode(charCode);
    }
    
    return btoa(encrypted);
  } catch (error) {
    console.error('Error encrypting partner_id:', error);
    return partnerId;
  }
}

export function decryptPartnerId(encryptedPartnerId: string): string {
  if (!encryptedPartnerId) {
    return '';
  }

  try {
    const decoded = atob(encryptedPartnerId);
    const key = ENCRYPTION_KEY;
    
    let decrypted = '';
    for (let i = 0; i < decoded.length; i++) {
      const charCode = decoded.charCodeAt(i) ^ key.charCodeAt(i % key.length);
      decrypted += String.fromCharCode(charCode);
    }
    
    return decrypted;
  } catch (error) {
    console.error('Error decrypting partner_id:', error);
    return encryptedPartnerId;
  }
}

export function isEncrypted(value: string): boolean {
  if (!value) {
    return false;
  }
  
  try {
    atob(value);
    return value.length > 20;
  } catch {
    return false;
  }
}
